import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { RenderChoiceLabel } from '@mentimeter/visualizations-react/types/render-options-by-slide-type';
import type { RankingBarsRenderChoiceVisualization } from '@mentimeter/visualizations-react/types/render-options-by-slide-type/ranking';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { Ranking } from '@mentimeter/visualizations-react/visualizations/ranking';
import type { LabeledRankingResult } from './types';

interface RankingVisualizationProps {
  shouldAnimate: boolean;
  shouldHideResults: boolean;
  labeledResults: LabeledRankingResult[];
  renderChoiceVisualization?: RankingBarsRenderChoiceVisualization | undefined;
  renderChoiceLabel?: RenderChoiceLabel | undefined;
  getOrderedListStyle?:
    | ((props: {
        index: number;
        key: string;
        length: number;
      }) => React.CSSProperties)
    | undefined;
  choiceLabelsContainerClassName?: string | undefined;
}

export const RankingVisualization = ({
  shouldAnimate,
  shouldHideResults,
  labeledResults,
  renderChoiceVisualization,
  renderChoiceLabel,
  getOrderedListStyle,
  choiceLabelsContainerClassName,
}: RankingVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      colors: { border },
      fonts: { body },
    },
  } = useRagnar();

  const colors = fillColors.length > 0 ? fillColors : [textColor];

  return (
    <Box width="100%" height="100%" px="4%">
      <FullSizeContainer>
        {(width, height) => (
          <Ranking
            width={width}
            height={height}
            colors={colors as [string, ...[string]]}
            textColor={textColor}
            placeholderColor={border}
            data={labeledResults}
            staticOptions={labeledResults}
            fontFamily={body}
            disableAnimations={!shouldAnimate}
            isScoreHidden={shouldHideResults}
            renderChoiceVisualization={renderChoiceVisualization}
            renderChoiceLabel={renderChoiceLabel}
            getOrderedListStyle={getOrderedListStyle}
            choiceLabelsContainerClassName={choiceLabelsContainerClassName}
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
